<script setup lang="ts">
    defineProps<{
        a11yLabel?: string;
    }>();
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        :role="a11yLabel ? 'img' : 'presentation'"
        :aria-label="a11yLabel"
        :aria-hidden="!a11yLabel"
    >
        <path d="m9 18 6-6-6-6" />
    </svg>
</template>
